import React from 'react';
import { Link } from 'react-router-dom';

export interface AboutProps {}

const About: React.FC<AboutProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1 style={{ marginLeft: -16 }}>Welcome</h1>
            <h3>I'm Cire Dye Ba</h3>
            <br />
            <div className="text-block">
                <p>
                    Strategic Narrative Director. Information is the new
                    battlefield — and I engineer dominance.
                </p>
                <br />
                <p>
                    You have reached the War Room: my private terminal. Feel
                    free to explore. For strategic inquiries, use the{' '}
                    <Link to="/contact">contact page</Link> or reach me directly
                    at{' '}
                    <a href="mailto:cba@black.com">cba@black.com</a>
                </p>
            </div>
            <div className="text-block">
                <h3>The Architecture of Influence</h3>
                <br />
                <p>
                    A Strategic Narrative Director transforms fragmented
                    information into coherent storylines that shape perception,
                    protect reputation, and establish information dominance.
                </p>
                <br />
                <p>
                    I've spent twelve years at the intersection of cognitive
                    psychology, intelligence tradecraft, and precision
                    storytelling. I turn chaos into clarity for governments,
                    corporations, and high-net-worth individuals facing complex
                    narrative threats.
                </p>
                <br />
                <p>
                    From sovereign-state situation rooms to HNWI living rooms, I
                    convert raw intelligence (sociotechnical data, weak signals,
                    adversarial networks) into executive-grade narratives that
                    accelerate decision-making, reassure stakeholders, and
                    safeguard reputation in contested information environments.
                </p>
                <br />
                <div style={styles.statsRow}>
                    <div style={styles.stat}>
                        <h1>12</h1>
                        <p>
                            <b>Years Active</b>
                        </p>
                    </div>
                    <div style={styles.stat}>
                        <h1>15+</h1>
                        <p>
                            <b>Countries</b>
                        </p>
                    </div>
                    <div style={styles.stat}>
                        <h1>40+</h1>
                        <p>
                            <b>Campaigns</b>
                        </p>
                    </div>
                    <div style={styles.stat}>
                        <h1>Top</h1>
                        <p>
                            <b>Clearance</b>
                        </p>
                    </div>
                </div>
                <br />
                <p>
                    My areas of operation are detailed on the{' '}
                    <Link to="/experience">Expertise</Link> page. Selected
                    strategic analyses are declassified under{' '}
                    <Link to="/projects">Dossiers</Link>.
                </p>
                <br />
                <br />
                <p>
                    One last thing: this machine holds more than dossiers.
                    Somewhere between the classified files, there are a few
                    games from another era. Consider them a test of patience —
                    the first virtue of narrative warfare. Good luck and have
                    fun!
                </p>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    contentHeader: {
        marginBottom: 16,
        fontSize: 48,
    },
    statsRow: {
        justifyContent: 'space-between',
        width: '100%',
    },
    stat: {
        flexDirection: 'column',
        alignItems: 'center',
        padding: 16,
    },
};

export default About;
